const mutations = {
  SET_MISC_NOTIFICATIONS(state, notifications) {
    state.miscNotifications = notifications;
  },
  REFRESH_PAUSE_NOTIFICATIONS(state) {
    state.pauseNotifications.forEach((notification) => {
      notification.agent_notify_read = notification.agent_notify_read_display;
    });
  },
  APPEND_PAUSE_NOTIFICATION(state, notification) {
    state.pauseNotifications.push(notification);
  },
  TOGGLE_READ(state, agentNotifyId) {
    const miscNotificationToReadIndex = state.miscNotifications.findIndex(
      (notification) => notification.agent_notify_id === agentNotifyId,
    );
    const pauseNotificationToReadIndex = state.pauseNotifications.findIndex(
      (notification) => notification.agent_notify_id === agentNotifyId,
    );
    if (miscNotificationToReadIndex > -1) {
      const notificationToRead = {
        ...state.miscNotifications[miscNotificationToReadIndex],
      };
      const currentReadState = notificationToRead.agent_notify_read_display;
      notificationToRead.agent_notify_read_display =
        currentReadState === 'Y' ? 'N' : 'Y';
      state.miscNotifications.splice(
        miscNotificationToReadIndex,
        1,
        notificationToRead,
      );
    } else if (pauseNotificationToReadIndex > -1) {
      const notificationToRead = {
        ...state.pauseNotifications[pauseNotificationToReadIndex],
      };
      const currentReadState = notificationToRead.agent_notify_read;
      notificationToRead.agent_notify_read_display =
        currentReadState === 'Y' ? 'N' : 'Y';
      state.pauseNotifications.splice(
        pauseNotificationToReadIndex,
        1,
        notificationToRead,
      );
    }
  },
  READ_ALL(state) {
    const allNotifications = [
      ...state.miscNotifications,
      ...state.pauseNotifications,
    ];
    allNotifications.forEach((notification) => {
      notification.agent_notify_read_display = 'Y';
    });
  },
};

export default mutations;
